import type { Photo } from '../types';

interface PhotoFromRenderMapImagesEvent {
  attributes: Photo;
}

/**
 * 
 * Takes an array of photos from the `RenderMapImages` event
 * Filters out any that do not have the required attributes ie. lat, lng, thumbnail, id, photoId, large
 * Returns an array of Photo objects with the required attributes.
 */
export const getPhotosWithAttributes = (photosFromRenderMapImagesEvent: PhotoFromRenderMapImagesEvent[]): Photo[] => {
  return photosFromRenderMapImagesEvent
  .filter(({ attributes }) => { // Remove photos without required attributes
    const { lat, lng, thumbnail, id, photo_id: photoId, large } = attributes || {};
    return (
      typeof lat === 'number' && // lat can be 0 which is falsey, so need to check type
      typeof lng === 'number' && // lng can be 0 which is falsey, so need to check type
      thumbnail &&
      id &&
      photoId && // photoId is needed for StravaMediaLightbox
      large // large is needed for StravaMediaLightbox
    );
  })
  .map(photo => photo.attributes); // Extract and return the attributes
};

export default getPhotosWithAttributes;